<template>
  <div class="c-progress-bar">
    <div class="c-progress-bar__wrapper">
      <div class="c-progress-bar__step-wrapper">
        <div
          v-for="(step, index) in steps"
          :key="step"
          :class="{
            'c-progress-bar__step--active': index == currentStepByCategory,
            'c-progress-bar__step--valid': index < currentStepByCategory,
          }"
          class="c-progress-bar__step"
        >
          <span class="c-progress-bar__label">{{ step }}</span>
          <div
            v-if="index !== steps.length - 1"
            class="c-progress-bar__progress"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  created() {},
  components: {},
  mounted() {},
  methods: {},
  computed: {
    ...mapFields(["config.currentStep", "viewContent.Categories"]),
    ...mapGetters(["getSlidesCount"]),
    steps() {
      let steps = ["Home"];
      this.Categories.forEach((category) => {
        if (category.Questions.length > 0) {
          steps.push(category.Name);
        }
      });
      steps.push("Results");
      return steps;
    },
    currentStepByCategory() {
      let currentCategoryIndex = 0;
      if (this.currentStep == 0) {
        currentCategoryIndex = 0;
      }

      let questionPosition = 1; //this is the slider count which will be a bigger number than the top nav
      let categoryPosition = 1; //this will be the index of the category in the top nav

      this.Categories.forEach((category) => {
        if (category.Questions.length > 0) {
          category.Questions.forEach((question) => {
            if (this.currentStep == questionPosition) {
              currentCategoryIndex = categoryPosition;
            }
            questionPosition++;
          });
          categoryPosition++;
        }
      });

      if (this.currentStep == this.getSlidesCount - 1) {
        currentCategoryIndex = this.getSlidesCount - 1;
      }

      return currentCategoryIndex;
    },
  },
};
</script>
<style lang="scss">
.c-progress-bar {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 70px;
  margin-bottom: 10px;

  @media (max-width: 755px) {
    padding-top: 35px;
    padding-bottom: 50px;
  }
}

.c-progress-bar__wrapper {
  max-width: 1000px;
  width: 100%;
}

.c-progress-bar__step-wrapper {
  display: flex;
  text-align: center;
  //background-color: white;
  padding: 0.13rem 0.15rem;
}

.c-progress-bar__step {
  flex: 1 1 0px;
  position: relative;

  &--active {
    .c-progress-bar__label {
      color: #FFFFFF;
    }

    .c-progress-bar__progress {
      &:before {
        content: "";
        height: 14px;
        width: 15px;
        background-color: #04b776;
        position: absolute;
        left: 0;
        top: 3px;
        border-radius: 0px 14px 14px 0px;
        z-index: 1;
      }
    }
  }

  &--valid {
    .c-progress-bar__progress {
      // background-color: #04b776;

      &::before {
        content: "";
        width: 100%;
        max-width: 100%;
        position: absolute;
        background: #04b776;
        // left: 3px;
        left: 0;
        height: 14px;
        // border-radius: 14px 0 0 14px;
        top: 3px;
        z-index: 1;
      }
    }
  }

  &:first-child {
    .c-progress-bar__progress {
      border-radius: 20px 0 0 20px;
    }
    &.c-progress-bar__step--active {
      .c-progress-bar__progress {
        &::before {
          left: 3px;
          border-radius: 14px;
        }
      }
    }
    &.c-progress-bar__step--valid {
      .c-progress-bar__progress {
        &::before {
          left: 3px;
          border-radius: 14px 0 0 14px;
        }
      }
    }
  }

  &:nth-last-child(2) {
    .c-progress-bar__progress {
      border-radius: 0px 20px 20px 0px;
      &::before {
        left: -3px; //offset for end
        border-radius: 0px 14px 14px 0px;
      }
    }
  }
}

.c-progress-bar__label {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: black;

  position: absolute;
  top: 30px;
  left: 0;
  right: 0;

  @media (max-width: 755px) {
    display: none;
  }
}

.c-progress-bar__progress {
  width: 100%;
  height: 20px;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;

  &:after{
    content: "";
    height: 14px;
    width: 100%;
    background-color: #e4e4e4;
    position: absolute;
    left: 0;
    top: 3px;
    border-radius: 0px 0px 0px 0px;
    z-index: 0;
  }

}
</style>
